/**
 * Legacy (“classic”) web app — richer grid/boardroom UX on a dedicated subdomain.
 * Main app links here; configure origin via env for staging (e.g. preview URLs).
 */

const DEFAULT_CLASSIC_ORIGIN = 'https://classic.takeover.fun';

/** Public origin of the classic deployment (no trailing slash). */
export function getClassicAppOrigin(): string {
  const raw = process.env.NEXT_PUBLIC_CLASSIC_APP_URL?.trim();
  if (raw) return raw.replace(/\/$/, '');
  return DEFAULT_CLASSIC_ORIGIN;
}

/** Hostname for display (e.g. footer copy). */
export function getClassicAppDisplayHost(): string {
  try {
    return new URL(getClassicAppOrigin()).hostname;
  } catch {
    return 'classic.takeover.fun';
  }
}

/**
 * Absolute URL on the classic app.
 * @param path - path starting with `/` (default `/`).
 */
export function classicAppUrl(path = '/'): string {
  const origin = getClassicAppOrigin();
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${origin}${p}`;
}
